import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-mensaje-importante',
    templateUrl: './mensaje-importante.component.html',
    styleUrls: ['./mensaje-importante.component.scss'],
    standalone: false
})
export class MensajeImportanteComponent {
  @Input() mensaje: string = 'Te recordamos que debes solicitar tu reevaluación de Pensión de Invalidez.';
  @Input() titulo: string = 'Importante';
  constructor() { }


}
